import { render, staticRenderFns } from "./DonutAptitudeAvisChart.vue?vue&type=template&id=63a4e9b5&"
import script from "./DonutAptitudeAvisChart.vue?vue&type=script&lang=ts&"
export * from "./DonutAptitudeAvisChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports